"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var OnEscapeHoC_1 = require("./OnEscapeHoC");
exports.default = OnEscapeHoC_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/behaviors/OnEscapeHoC/index.js
// module id = 1299
// module chunks = 8